webpackJsonp([0],{

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfilePanel_vue__ = __webpack_require__(681);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40851aae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfilePanel_vue__ = __webpack_require__(689);
function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40851aae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfilePanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40851aae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfilePanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(97);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserProfilePanel',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('auth', ['username']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    global: function global(state) {
      return state.global;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    account: function account(state) {
      return state.account;
    }
  }), {
    vestingSteem: function vestingSteem() {
      return this.formatterVestingSteem(this.account.vestingShares);
    },
    delegatedVestingSteem: function delegatedVestingSteem() {
      return this.formatterVestingSteem(this.account.delegatedVestingShares);
    },
    receivedVestingSteem: function receivedVestingSteem() {
      return this.formatterVestingSteem(this.account.receivedVestingShares);
    },
    totalSteemPower: function totalSteemPower() {
      return this.vestingSteem + this.delegatedVestingSteem + this.receivedVestingSteem;
    },
    votePower: function votePower() {
      var elapsedSeconds = (new Date() - new Date(this.account.lastVoteTime + 'Z')) / 1000; // 마지막 보팅 후 경과 시간
      var regeneratedPower = 10000 * elapsedSeconds / (60 * 60 * 24 * 5); // 재생된 보팅파워
      var currentPower = Math.round(Math.min(this.account.votingPower + regeneratedPower, 10000)); // 현재 보팅파워
      return currentPower / 100 || 0;
    },
    remainHours: function remainHours() {
      return (10000 - this.votePower) * (5 * 60 * 60 * 24) / (60 * 60 * 10000);
    },
    upvoteValue: function upvoteValue() {
      var rate = parseInt((this.votePower * 100 + 49) / 50) * 100;
      // console.log('rate:', rate)
      var upvoteValue = this.totalSteemPower / (this.global.totalVestingFundSteem / this.global.totalVestingShares) * rate * (this.global.rewardBalance / this.global.recentClaims);
      // console.log('upvoteValue1:', upvoteValue)
      upvoteValue = upvoteValue * this.global.price;
      // console.log('upvoteValue2:', upvoteValue)
      return upvoteValue || 0;
    }
  }),
  // beforeMount () {
  created: function created() {
    console.log('getAccounts');
    this.$store.dispatch('global/loadGlobalProperties');
    this.$store.dispatch('account/loadAccount', this.username);
  },
  mounted: function mounted() {
    console.log('account', this.account);
  },

  methods: {
    formatterVestingSteem: function formatterVestingSteem(vestingShares) {
      return this.global.totalVestingFundSteem * (vestingShares / this.global.totalVestingShares);
    }
  }
});

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(669)("589a9c71", content, true, {});

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(668)(true);
// imports


// module
exports.push([module.i, ".v-avatar[data-v-40851aae]{margin:-120px 0 0 15px}.v-avatar img[data-v-40851aae]{border:2px solid #fff}.username[data-v-40851aae]{position:absolute;top:26px;left:95px;color:#fff;line-height:160%;font-weight:700;text-shadow:0 0 4px rgba(0,0,0,.8)}.username>span[data-v-40851aae]:first-child{font-size:32px}@media only screen and (max-width:959px){.v-card__title[data-v-40851aae]{padding:0}}", "", {"version":3,"sources":["C:/workspace/steemit-app/src/components/panels/UserProfilePanel.vue"],"names":[],"mappings":"AACA,2BACE,sBAA4B,CAC7B,AACD,+BACE,qBAAsB,CACvB,AACD,2BACE,kBAAmB,AACnB,SAAU,AACV,UAAW,AACX,WAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,kCAAoC,CACrC,AACD,4CACE,cAAgB,CACjB,AACD,yCACA,gCACI,SAAW,CACd,CACA","file":"UserProfilePanel.vue","sourcesContent":["\n.v-avatar[data-v-40851aae] {\r\n  margin: -120px 0px 0px 15px;\n}\n.v-avatar img[data-v-40851aae] {\r\n  border: 2px solid #fff\n}\n.username[data-v-40851aae] {\r\n  position: absolute;\r\n  top: 26px;\r\n  left: 95px;\r\n  color: white;\r\n  line-height: 160%;\r\n  font-weight:bold;\r\n  text-shadow: 0 0 4px rgba(0,0,0,.8);\n}\n.username > span[data-v-40851aae]:first-child {\r\n  font-size: 32px;\n}\n@media only screen and (max-width: 959px) {\n.v-card__title[data-v-40851aae] {\r\n    padding: 0;\n}\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.account.name)?_c('v-card',[_c('v-card-media',[_c('img',{attrs:{"src":'https://steemitimages.com/0x100/' + _vm.account.coverImage}})]),_vm._v(" "),_c('v-avatar',{attrs:{"size":"64"}},[_c('img',{attrs:{"src":'https://steemitimages.com/128x128/' + _vm.account.profileImage}})]),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0"},[_c('div',{staticClass:"username"},[_c('span',[_vm._v(_vm._s(_vm.account.name))]),_vm._v(" "),_c('span',[_vm._v("("+_vm._s(_vm.account.reputation)+")")]),_vm._v(" "),_c('div',[_vm._v("@"+_vm._s(_vm.username))])]),_vm._v(" "),_c('div',{staticClass:"hidden-sm-and-down"},[_vm._v("수면의 과학")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('div',[_c('v-icon',{attrs:{"small":""}},[_vm._v("power")]),_vm._v(" 보팅 파워: "+_vm._s(this.votePower.toFixed(2))+"%")],1),_vm._v(" "),_c('div',[_c('v-icon',{attrs:{"label":"","small":""}},[_vm._v("attach_money")]),_vm._v(" 보팅 금액: $"+_vm._s(_vm.upvoteValue.toFixed(3)))],1)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.960e7bd8c2975719bcd1.js